var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92673 11.3205C10.2887 11.6049 10.5 12.0397 10.5 12.5V19.8821L13.5 18.8265V12.5C13.5 12.0397 13.7113 11.6049 14.0733 11.3205L19.9267 6.72137C20.2887 6.43699 20.5 6.00219 20.5 5.54189V4C20.5 3.72386 20.2761 3.5 20 3.5H4C3.72386 3.5 3.5 3.72386 3.5 4V5.54189C3.5 6.00219 3.71133 6.43699 4.07327 6.72137L9.92673 11.3205ZM20.8535 7.90085C21.5773 7.33209 22 6.46248 22 5.54189V4C22 2.89543 21.1046 2 20 2H4C2.89543 2 2 2.89543 2 4V5.54189C2 6.46248 2.42266 7.33209 3.14654 7.90085L9 12.5V20.5881C9 21.2776 9.68145 21.7602 10.3319 21.5314L14.3319 20.124C14.7322 19.9831 15 19.605 15 19.1806V12.5L20.8535 7.90085Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1d330982529230a959fe81cc12ddf1aa.svg";
export { ForwardRef as ReactComponent };